/**
 * Article metadata for the knowledge base.
 *
 * Discovered automatically by `generate-kb-catalog.mjs` (runs on `yarn start` and
 * `yarn build`). The slug must match this folder name.
 */
export const meta = {
  slug: 'what-is-pulsewatch',
  title: 'What is PulseWatch?',
  category: 'Getting started',
  summary:
    'An overview of PulseWatch: public status pages backed by uptime checks, error tracking and request tracing for your own applications, and how they fit together.',
  keywords: ['PulseWatch', 'overview', 'status page', 'uptime monitoring', 'error tracking', 'tracing'],
};

export const loadComponent = () => import('./what-is-pulsewatch.component').then((m) => m.WhatIsPulsewatchArticleComponent);
